import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { UserActivitiesService } from './user-activities.service';

declare var $: any;
import * as _ from 'lodash';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { PrimeTemplate, Footer } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
    selector: 'act-pop',
    templateUrl: 'activity-popup.component.html',
    standalone: true,
    imports: [DialogModule, PrimeTemplate, TooltipModule, DropdownModule, FormsModule, MultiSelectModule, Footer, TranslateModule]
})
export class ActivityPopUpComponent implements OnInit {
  private service = inject(UserActivitiesService);
  private translate = inject(TranslateService);


  activities: any[];
  periodOptions: any;
  stateOptions: any;
  typologyList: any[];
  selectedTypologies = [];

  state: string;
  status: string;

  typterm: string;

  data: string;
  display: boolean = false;

  @Input() idx: number;
  @Input() params: any;

  @Output() closepopup: EventEmitter<boolean> = new EventEmitter();
  @Output() saveData: EventEmitter<{ params: any, indx: number }> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.periodOptions = [
      { name: this.translate.instant('widgets.party-activities.Week'), value: 'Week' },
      { name: this.translate.instant('widgets.party-activities.Day'), value: 'Day' },
      { name: this.translate.instant('widgets.party-activities.Month'), value: 'Month' }
    ];

    this.stateOptions = [
      { name: this.translate.instant('widgets.party-activities.All'), value: 'All' },
      { name: this.translate.instant('widgets.party-activities.OpenedAndWorking'), value: 'OpenedAndWorking' },
      { name: this.translate.instant('widgets.party-activities.Closed'), value: 'Closed' }
    ];
  }

  ngOnInit(): void {
    this.state = "All";
    this.data = "Week";

    if (this.params) {
      if (this.params.state)
        this.state = this.params.state;

      if (this.params.date)
        this.data = this.params.date;
    }

    this.service
      .getActivityTypologies()
      .subscribe(typ => {
        this.typologyList = typ;
      });

    this.display = true;
  }

  getData(name: string) {
    return 'widgets.party-activities.' + name;
  }

  getState(state: string) {
    return 'widgets.party-activities.' + state;
  }

  cancel() {
    this.closepopup.next(true);
  }

  clearDefault() {
    this.state = "All";
    this.data = "Week";

    this.service
      .getActivityTypologies()
      .subscribe(typ => {
        this.typologyList = typ;
        this.selectedTypologies = [];
      })
  }

  confirm() {
    let typologies = null;

    if (this.selectedTypologies && this.selectedTypologies.length > 0)
      typologies = this.selectedTypologies;

    let parms = {
      state: this.state,
      date: this.data,
      typologies: typologies
    }

    this.saveData.next({ params: parms, indx: this.idx });
    this.display = false;
    this.closepopup.next(true);
  }
}
